import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { APIService } from '../../services/api/api.service';

import * as CannedMessageActions from './canned-messages.actions';

@Injectable()
export class CannedMessageEffects {
  constructor(
    private actions$: Actions,
    private apiService: APIService
  ) {}

  getCannedMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CannedMessageActions.getCannedMessages),
      switchMap(action =>
        this.apiService.getCannedMessages(action.query).pipe(
          map(cannedMessages =>
            CannedMessageActions.getCannedMessagesSuccess({ cannedMessages })
          ),
          catchError(error => of(CannedMessageActions.getCannedMessagesFailure({ error })))
        )
      )
    )
  );

  addCannedMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CannedMessageActions.addCannedMessage),
      switchMap(action =>
        this.apiService.addCannedMessage(action.cannedMessage).pipe(
          map(cannedMessage =>
            CannedMessageActions.addCannedMessageSuccess({ cannedMessage })
          ),
          catchError(error => of(CannedMessageActions.addCannedMessageFailure({ error })))
        )
      )
    )
  );

  deleteCannedMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CannedMessageActions.deleteCannedMessage),
      switchMap(action =>
        this.apiService.deleteCannedMessage(action.id).pipe(
          map(() => CannedMessageActions.deleteCannedMessageSuccess({ id: action.id })),
          catchError(error => of(CannedMessageActions.deleteCannedMessageFailure({ error })))
        )
      )
    )
  );

  updateCannedMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CannedMessageActions.updateCannedMessage),
      switchMap(action =>
        this.apiService.updateCannedMessage(action.cannedMessage).pipe(
          map(cannedMessage =>
            CannedMessageActions.updateCannedMessageSuccess({ cannedMessage })
          ),
          catchError(error => of(CannedMessageActions.updateCannedMessageFailure({ error })))
        )
      )
    )
  );
}
